<header class="share-header">
  <div class="header-left">
    <img
      src="assets/images/dairector-logo.svg"
      alt="dAIrector"
      class="header-logo"
    />
    <img
      src="assets/images/dairector-logomark.svg"
      alt="dAIrector"
      class="header-logomark"
    />
    <div class="header-sep"></div>
    <div class="header-context">
      @if (breadcrumb?.project) {
        <span class="header-project">{{ breadcrumb.project }}</span>
        <span class="header-chevron">&rsaquo;</span>
      }
      <span class="header-title">{{ breadcrumb?.title }}</span>
      @if (breadcrumb?.stageBadge) {
        <span class="badge font-10" [ngClass]="breadcrumb?.stageBadgeClass">
          {{ breadcrumb.stageBadge }}
        </span>
      }
    </div>
  </div>
  @if (aspectRatioOptions.length) {
    <div class="header-center sb-aspect-ratio-selector">
      <span class="sb-aspect-ratio-label">Aspect ratio</span>
      <div class="sb-aspect-ratio-toggle">
        @for (aspectRatio of aspectRatioOptions; track aspectRatio.id) {
          <button
            type="button"
            class="aspect-ratio-btn"
            [class.active]="selectedAspectRatioId === aspectRatio.id"
            [attr.aria-pressed]="selectedAspectRatioId === aspectRatio.id"
            (click)="aspectRatioSelect.emit(aspectRatio.id)"
          >
            {{ aspectRatio.ratio }}
          </button>
        }
      </div>
    </div>
  }
  <div class="header-right">
    @if (showDownload) {
      <button class="btn-copy-link" [disabled]="downloading" (click)="downloadClick.emit()">
        <app-icon name="download" [size]="14"></app-icon>
        <span class="btn-copy-link-label">{{ downloading ? 'Downloading...' : 'Download' }}</span>
      </button>
    }
    @if (asset_id && video_id) {
      <button class="btn-copy-link" (click)="openCopyLinkModal()">
        <app-icon name="link" [size]="14"></app-icon>
        <span class="btn-copy-link-label">Copy Link</span>
      </button>
    }
    @if (!hideCommentsToggle) {
      <button
        class="btn-comments-toggle"
        [class.active]="commentsOpen"
        (click)="onCommentsClick()"
      >
        <app-icon name="message" [size]="16"></app-icon>
        @if (commentCount > 0) {
          <span class="comment-count-badge">{{ commentCount }}</span>
        }
      </button>
    }
    <span
      nz-popover
      [nzPopoverContent]="contentTemplate"
      nzPopoverPlacement="top"
      nzPopoverOverlayClassName="common-popover-design-v1"
    >
      <app-user-avatar
        [userDetails]="
          sharedService.createObjectFromMultipleKeys({
            userId: user?.user_id,
            firstName: user?.firstname,
            lastName: user?.lastname,
            profile: user?.profile,
          })
        "
        [showUserName]="false"
        [customWidth]="'32px'"
      ></app-user-avatar>

      <ng-template #contentTemplate>
        <div class="menu-container">
          <div class="profile-section">
            <app-user-avatar
              [userDetails]="
                sharedService.createObjectFromMultipleKeys({
                  userId: user?.id,
                  firstName: user?.firstname,
                  lastName: user?.lastname,
                  profile: user?.profile,
                })
              "
              [showUserName]="false"
              [customWidth]="'56px'"
            ></app-user-avatar>
            <div class="profile-info">
              <div class="profile-name">
                {{ user?.firstname }}
                {{ user?.lastname }}
              </div>
              <div class="profile-email">{{ user?.email }}</div>
            </div>
          </div>

          <ul class="menu-items">
            <li class="menu-item logout" (click)="logout()">
              <div class="icon">
                <app-icon
                  name="logout"
                  [size]="20"
                  color="currentColor"
                  [strokeWidth]="2"
                ></app-icon>
              </div>
              <span>Logout</span>
            </li>
          </ul>
        </div>
      </ng-template>
    </span>
  </div>
</header>
